import { useEffect, useRef } from 'react'

import { Nullable } from 'models/helpers'
import { PlatformUserBase } from 'models/user'
import { initBecka } from './becka'
import { logger } from 'utils/logging'

/**
 * Starts the Salesforce messaging chat once the user and their token are known, and while `enabled`. Never on an
 * embed route (ISSUE-2310), where its script is not even loaded. A failed attempt is retried on the next
 * user or token change.
 */
export function useBecka(
  token: Nullable<string>,
  userData: Nullable<PlatformUserBase>,
  isEmbed: boolean,
  enabled = true
) {
  const isRequested = useRef(false)

  useEffect(() => {
    if (!enabled || !userData || isRequested.current || !token || isEmbed) return
    // Claimed before the script has loaded, so a re-render meanwhile cannot load or init it twice.
    isRequested.current = true
    initBecka(token, userData, userData.language?.toLowerCase())
      .then((initialized) => {
        if (!initialized) isRequested.current = false
      })
      .catch((error) => {
        // Only a build without the REACT_APP_BECKA_* values gets here.
        isRequested.current = false
        logger.error('Becka chat not started', error, { context: { component: 'useBecka', action: 'init' } })
      })
  }, [userData, token, isEmbed, enabled])
}
